import { render, staticRenderFns } from "./BorderVisualizer.vue?vue&type=template&id=6f657072&scoped=true&"
import script from "./BorderVisualizer.vue?vue&type=script&lang=js&"
export * from "./BorderVisualizer.vue?vue&type=script&lang=js&"
import style0 from "./BorderVisualizer.vue?vue&type=style&index=0&id=6f657072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f657072",
  null
  
)

export default component.exports